import { Button } from './ui/button';

/**
 * The one empty-state pattern for workspace modules (review #9): big muted
 * icon, heading, one-line description, single primary CTA. Pass `compact`
 * for inline/dashed placeholders that sit inside an existing card flow.
 */
export default function EmptyState({ icon: Icon, title, description, ctaLabel, onCta, compact = false, testId = 'empty-state' }) {
  if (compact) {
    return (
      <div className="border border-dashed border-border/40 p-16 text-center" data-testid={testId}>
        {Icon && <Icon className="w-12 h-12 text-muted-foreground/30 mx-auto mb-4" />}
        <p className="font-mono text-muted-foreground text-sm uppercase tracking-widest">{title}</p>
      </div>
    );
  }
  return (
    <div className="bg-card border border-border/40 p-16 text-center" data-testid={testId}>
      {Icon && <Icon className="w-16 h-16 text-muted-foreground mx-auto mb-6" />}
      <h3 className="font-mono text-xl font-semibold mb-3">{title}</h3>
      {description && <p className="text-muted-foreground mb-6">{description}</p>}
      {ctaLabel && onCta && (
        <Button
          onClick={onCta}
          className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-none font-mono uppercase tracking-widest text-xs px-6 py-3"
        >
          {ctaLabel}
        </Button>
      )}
    </div>
  );
}
